import { Text } from "@clipboard-health/ui-react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton, useTheme } from "@mui/material";
import { APP_BAR_COLORS } from "@src/appV2/lib/Theme";
import { PlayerEventType, PlayerState } from "amazon-ivs-player";

import { IvsVideoPlayer } from "./IvsVideoPlayer";

export interface FullScreenVideoPlayerProps {
  onClose: () => void;
  onVideoEventListener: (eventType: PlayerEventType | PlayerState) => void;
  streamUrl: string;
  title: string;
}

export function FullScreenVideoPlayer(props: FullScreenVideoPlayerProps) {
  const { onClose, onVideoEventListener, streamUrl, title } = props;
  const theme = useTheme();

  if (!streamUrl) {
    return null;
  }

  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullScreen
      // here we're using PaperPros to set the background color
      // of app to match with the component's color
      // Also we're overriding the theme's x and bottom padding to
      // give full screen experience of the video
      PaperProps={{
        sx: {
          backgroundColor: APP_BAR_COLORS.backgroundColors.light,
          paddingX: 0,
          paddingBottom: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          paddingX: 0,
          paddingY: 1,
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          color: theme.palette.common.white,
        }}
      >
        <IconButton
          size="large"
          color="inherit"
          title="close"
          onClick={onClose}
          aria-label="video-close-button"
        >
          <CloseIcon />
        </IconButton>
        <Text noWrap color="inherit">{`${title} Video`}</Text>
        <IconButton disabled size="large" color="inherit">
          <CloseIcon sx={{ visibility: "hidden" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <IvsVideoPlayer onVideoEventListener={onVideoEventListener} streamUrl={streamUrl} />
      </DialogContent>
    </Dialog>
  );
}
